var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 16V12.6667M10 12.6667V8H12.6667C13.9553 8 15 9.04467 15 10.3333V10.3333C15 11.622 13.9553 12.6667 12.6667 12.6667H10Z", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("rect", { x: "4", y: "4", width: "16", height: "16", rx: "2", stroke: "#303030", strokeWidth: "1.5" })
  );
});